<template>
    <section class="interview-title light yellow">
        <div class="css-grid panel-left">
            <div class="bg" style="background-image: url(/static/img/pages/interview-erdinc.jpg)"></div>

            <div class="content-wrapper">
                <div class="content light yellow">
                    <h3>Interview Erdin&ccedil;&nbsp;Sa&ccedil;an</h3>
                    <h2>Interactieve technologie maakt onderwijs leuker, effici&euml;nter en effectiever</h2>
                    <button @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped></style>

<script>
    import InterviewErdinc from '@/app/pages/sub/InterviewErdinc';

    export default {
        name: 'RegioInterview',
        meta: {
            title: 'RegioInterview',
            color: '#FEBE06'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewErdinc );
            }
        }
    };
</script>
